<template>
  <div>
    <!-- Search type -->
    <div class="mb-5 flex justify-center lg:mb-8">
      <div
        class="mx-auto inline-flex items-center rounded-full bg-white text-sm font-medium text-black-78 shadow-search"
      >
        <button
          class="flex items-center rounded-full bg-clip-padding py-3.5"
          :class="[
            typeOfSearch == 'Nepremičnine' ? 'bg-green text-white' : '',
            typeOfSearch != 'Nepremičnine' && $root.isMobileViewport
              ? 'px-5'
              : 'px-10 lg:px-12',
          ]"
          @click="typeOfSearch = 'Nepremičnine'"
        >
          <v-icon
            icon="house"
            size="5"
            :class="{
              'mr-2.5':
                (typeOfSearch == 'Nepremičnine' && $root.isMobileViewport) ||
                !$root.isMobileViewport,
            }"
          ></v-icon>
          <span
            class="whitespace-nowrap"
            v-if="
              (typeOfSearch == 'Nepremičnine' && $root.isMobileViewport) ||
              !$root.isMobileViewport
            "
            >Nepremičnine</span
          >
        </button>
        <button
          class="relative flex cursor-default items-center rounded-full py-3.5"
          :class="[
            typeOfSearch == 'Cenovni atlas' ? 'bg-green text-white' : '',
            typeOfSearch != 'Cenovni atlas' && $root.isMobileViewport
              ? 'px-5'
              : 'px-10 lg:px-12',
          ]"
        >
          <div
            class="absolute -right-[15px] -top-[15px] z-10 rounded-full bg-green-50 px-3 py-2 text-small-text-medium leading-[1.2] text-white shadow md:-right-2.5 md:-top-2.5 md:text-body-medium-button"
          >
            <template v-if="$root.isMobileViewport"> Kmalu! </template>
            <template v-else> Prihaja kmalu! </template>
          </div>
          <!-- @click="typeOfSearch = 'Cenovni atlas'" -->
          <v-icon
            class="opacity-20"
            icon="loupe-world"
            size="5"
            :class="{
              'mr-2.5':
                (typeOfSearch == 'Cenovni atlas' && $root.isMobileViewport) ||
                !$root.isMobileViewport,
            }"
          ></v-icon>
          <span
            class="whitespace-nowrap opacity-20"
            v-if="
              (typeOfSearch == 'Cenovni atlas' && $root.isMobileViewport) ||
              !$root.isMobileViewport
            "
            >Cenovni atlas</span
          >
        </button>
      </div>
    </div>
    <div
      class="w-full"
      v-if="typeOfSearch == 'Nepremičnine'"
      key="Nepremičnine"
    >
      <v-main-search-real-estate-mobile
        v-if="$root.isMobileViewport"
        :enums="enums"
        :i18n="i18n"
        :old="old"
        :rent-or-buy-options="parseEnums('vermarktungsart')"
        :realestate-type-options="parseEnums('objektart')"
        :current-country="currentCountry"
        :errors="errors"
      ></v-main-search-real-estate-mobile>
      <v-main-search-real-estate-desktop
        v-else
        :enums="enums"
        :i18n="i18n"
        :old="old"
        :rent-or-buy-options="parseEnums('vermarktungsart')"
        :realestate-type-options="parseEnums('objektart')"
        :current-country="currentCountry"
        :errors="errors"
      ></v-main-search-real-estate-desktop>
    </div>
    <div
      class="w-full"
      v-if="typeOfSearch == 'Cenovni atlas'"
      key="Cenovni atlas"
    >
      <v-main-search-price-atlas-mobile
        v-if="$root.isMobileViewport"
        :enums="enums"
        :i18n="i18n"
        :rent-or-buy-options="parseEnums('vermarktungsart')"
        :realestate-type-options="parseEnums('objektart')"
        :locations="[]"
        :errors="errors"
      ></v-main-search-price-atlas-mobile>
      <v-main-search-price-atlas-desktop
        v-else
        :enums="enums"
        :i18n="i18n"
        :rent-or-buy-options="parseEnums('vermarktungsart')"
        :realestate-type-options="parseEnums('objektart')"
        :locations="[]"
        :errors="errors"
      ></v-main-search-price-atlas-desktop>
    </div>
  </div>
</template>

<script>
import MainSearchRealEstateDesktop from "./MainSearchRealEstateDesktop.vue";
import MainSearchRealEstateMobile from "./MainSearchRealEstateMobile.vue";
import MainSearchPriceAtlasDesktop from "./MainSearchPriceAtlasDesktop.vue";
import MainSearchPriceAtlasMobile from "./MainSearchPriceAtlasMobile.vue";

export default {
  name: "MainSearch",

  components: {
    "v-main-search-real-estate-desktop": MainSearchRealEstateDesktop,
    "v-main-search-real-estate-mobile": MainSearchRealEstateMobile,
    "v-main-search-price-atlas-desktop": MainSearchPriceAtlasDesktop,
    "v-main-search-price-atlas-mobile": MainSearchPriceAtlasMobile,
  },

  props: {
    i18n: {
      type: Object,
      required: true,
    },
    enums: {
      type: Object,
      required: true,
    },
    old: {
      type: Object,
      required: false,
      default: {},
    },
    errors: {
      type: Object,
      required: true,
      default: {},
    },
    currentCountry: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      typeOfSearch: "Nepremičnine",
    };
  },

  methods: {
    parseEnums(key) {
      let specificEnums = [];

      Object.values(this.enums).forEach((enumGroup) => {
        if (enumGroup.group == key) {
          Object.keys(enumGroup.values).forEach((enumGroupValueKey) => {
            specificEnums.push({
              value: enumGroupValueKey,
              label: enumGroup.values[enumGroupValueKey],
              icon: this.i18n[enumGroupValueKey]
                ? this.i18n[enumGroupValueKey].icon
                : "",
            });
          });
        }
      });

      return specificEnums;
    },
  },
};
</script>
